import moment from "moment";

const defaultLocale = "en";
const CURRENT_YEAR_DATE_FORMAT = "MMM DD";
const FULL_SHORT_DATE_FORMAT = "MMM DD YYYY";

type Options = {
    collapseCurrentYear?: boolean;
};

type DateType = moment.Moment | number | Date | string | undefined;

export const formatDate = (date: DateType) =>
    moment
        .utc(date)
        .format(moment.utc(date).year() === moment.utc().year() ? CURRENT_YEAR_DATE_FORMAT : FULL_SHORT_DATE_FORMAT);

export const formatDateRange = (dateStart: DateType, dateEnd: DateType, { collapseCurrentYear }: Options = {}) => {
    const dates = [dateStart, dateEnd]
        .map((date) => (date ? moment.utc(date) : null))
        .filter((moment) => moment && moment.isValid());
    let format = FULL_SHORT_DATE_FORMAT;
    if (collapseCurrentYear) {
        const currentYear = new Date().getFullYear();
        format = dates.every((date) => date.year() === currentYear) ? CURRENT_YEAR_DATE_FORMAT : FULL_SHORT_DATE_FORMAT;
    }
    return dates.map((date) => date.locale(defaultLocale).format(format)).join(" - ");
};
